<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="business-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-seller')"
                      to="business-seller">
              <i class="lnr-users btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Vendedores
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-shipping-company')"
                      to="business-shipping-company">
              <i class="lnr-bus btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Transportadoras
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-payment-plan')"
                      to="business-payment-plan">
              <i class="lnr-cart btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Planos de Pagamento
            </t-button>
          </div>



          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-type-service')"
                      to="business-type-service">
              <i class="lnr-store btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos de Serviços
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-delivery-plan')"
                      to="business-delivery-plan">
              <i class="lnr-calendar-full btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Prazos de Entrega
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-type-quote-status')"
                      to="business-type-quote-status">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status Orçamentos
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('business-type-order-status')"
                      to="business-type-order-status">
              <i class="lnr-file-add btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status Pedidos
            </t-button>
          </div>


        </div>
      </div>


    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'BusinessSetting',
  data() {
    return {

    }
  },
  methods: {

    mountedPrepare(){


    },
    async mountedContinued(){

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
